import Button from "@web-ui/components/Button";

/**
 * "Unsaved changes · Discard · Save", stuck to the bottom of the content while a page has edits
 * (Polaris' contextual save bar). One save for the whole page; nothing is lost by scrolling, and
 * the actions are always where the eye ends.
 */
export function SaveBar({ dirty, saving = false, onSave, onDiscard, saveLabel = "Save", note }: {
  dirty: boolean;
  saving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  saveLabel?: string;
  /** One line about where the change goes ("Reaches your apps at the next publish"). */
  note?: string;
}) {
  if (!dirty && !saving) return null;
  return (
    <div className="sticky bottom-3 z-10" role="region" aria-label="Unsaved changes">
      <div className="flex flex-wrap items-center gap-3 rounded-3xl border border-s-subtle bg-b-surface2 px-5 py-3 shadow-depth">
        <span className="flex flex-col">
          <span className="text-sub-title-2">Unsaved changes</span>
          {note ? <span className="text-caption text-t-secondary">{note}</span> : null}
        </span>
        <span className="grow" />
        <Button type="button" disabled={saving} onClick={onDiscard}>Discard</Button>
        <Button type="button" variant="primary" isPending={saving} disabled={saving} onClick={onSave}>{saveLabel}</Button>
      </div>
    </div>
  );
}
